import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Input } from "../components/ui/input";

const LOCAL_BANDS = [
  { value: "none", label: "No local Australian experience" },
  { value: "lt_1", label: "Less than 1 year" },
  { value: "1_3", label: "1 to 3 years" },
  { value: "gt_3", label: "More than 3 years" },
];

export const ExperienceStep = ({ totalYears, onTotalYears, localBand, onLocalBand }) => {
  return (
    <div data-testid="experience-step" className="space-y-8">
      <div>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
          Your experience
        </h2>
        <p className="text-slate-600 mt-1 text-sm sm:text-base">
          Two quick numbers — these tune the recommendation to your seniority
          and local-market readiness.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <div className="rounded-lg border border-slate-200 bg-white p-5">
          <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
            Total years of experience
          </label>
          <p className="mt-1 text-sm text-slate-600">
            Including overseas, internships and contracts.
          </p>
          <Input
            data-testid="total-years-input"
            type="number"
            min={0}
            max={50}
            step={0.5}
            value={totalYears}
            onChange={(e) => onTotalYears(Number(e.target.value))}
            className="mt-3 h-11"
          />
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-5">
          <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
            Australian local experience
          </label>
          <p className="mt-1 text-sm text-slate-600">
            Years working in roles based in Australia.
          </p>
          <div className="mt-3">
            <Select value={localBand} onValueChange={onLocalBand}>
              <SelectTrigger
                data-testid="local-band-select"
                className="h-11 bg-white"
              >
                <SelectValue placeholder="Select local experience" />
              </SelectTrigger>
              <SelectContent>
                {LOCAL_BANDS.map((b) => (
                  <SelectItem key={b.value} value={b.value}>
                    {b.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="rounded-md bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600">
        <span className="font-semibold text-slate-800">Note:</span> Local
        experience is treated as a readiness factor, not a rejection factor.
        It nudges your score; it doesn't disqualify you.
      </div>
    </div>
  );
};

export default ExperienceStep;
